export {
    default as subscribeNotificationAndGetChannelId,
} from './utils/subscribeNotificationAndGetChannelId';
